import { render, staticRenderFns } from "./RCAReportForm.vue?vue&type=template&id=8358fc8a&scoped=true&"
import script from "./RCAReportForm.vue?vue&type=script&lang=js&"
export * from "./RCAReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8358fc8a",
  null
  
)

export default component.exports